import styled from "styled-components";

export const BasketCardGrey = styled.div`
  background: ${({ theme }) => theme.customTheme.palette.BasketCardGrey.bgColor};
  margin-bottom: 12px;
  padding: 20px;
  border-radius: 12px;
`;

export const GreyCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const Img = styled.img`
  width: 80px;
  filter: brightness(0) invert(0);
  object-fit: contain;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 120px;
  }
`;

export const PriceAndTag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const Price = styled.span`
  font-size: 16px;
  font-family: ThemeFontRegular;
  font-weight: bold;
  line-height: 20px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  }
`;

export const TagAndIcon = styled.span`
  font-size: 14px;
  font-family: ThemeFontRegular;
  line-height: 20px;

  & svg {
    margin-right: 6px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  }
`;

export const Bold = styled.strong`
  font-size: 14px;
  font-family: ThemeFontRegular;
  line-height: 18px;
  text-transform: uppercase;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  }
`;

export const RemoveBtnArea = styled.div`
  display: flex;
`;

export const PartnerLogo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BasketCardFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TermsAndConditionsArea = styled.div`
  text-decoration: underline;
  cursor: pointer;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.TermsAndConditionsArea.color};
  font-family: ThemeFontBold;
  font-weight: 700;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  }
`;
